// removed by extract-text-webpack-plugin
module.exports = {"textLink":"_3LYyc"};